// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bpe6","label":"styles_label__3AbqL"};